import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useContent } from "@/lib/content";
import { PageLoader } from "@/pages/Home";
import { SocialLinks } from "@/components/site/Social";

export const POLICY_PAGES = [["terms", "/terms", "Terms & Conditions"], ["refund", "/refund-policy", "Refund & Cancellation"], ["privacy", "/privacy", "Privacy Policy"]];
export const policyPath = (k) => POLICY_PAGES.find(([key]) => key === k)[1];

const fmt = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "");

export const PolicyLinks = ({ dark = false }) => (
  <nav className={`policy-links ${dark ? "dark" : ""}`} aria-label="Policies" data-testid="policy-links">
    {POLICY_PAGES.map(([k, href, label]) => <Link key={k} to={href} data-testid={`policy-link-${k}`}>{label}</Link>)}
  </nav>
);

export const PolicyBar = () => {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname.startsWith("/admin")) return null;
  return <div className="policy-bar" data-testid="policy-bar"><SocialLinks /><PolicyLinks /></div>;
};

export const AgreeNote = ({ action = "booking" }) => (
  <small className="agree-note" data-testid={`agree-note-${action}`}>
    By {action} you agree to our <Link to="/terms" target="_blank">Terms &amp; Conditions</Link> and <Link to="/refund-policy" target="_blank">Refund &amp; Cancellation Policy</Link>.
  </small>
);

export default function PolicyPage({ which }) {
  const c = useContent().data;
  useEffect(() => { window.scrollTo(0, 0); }, [which]);
  if (!c) return <PageLoader />;
  const p = c.policies?.[which];
  if (!p) return null;
  return (
    <div className="wm policy-page" data-testid={`policy-page-${which}`}>
      <header className="look-top">
        <Link to="/" className="look-back" data-testid="policy-back-link"><ArrowLeft size={18} /> Home</Link>
        <Link to="/" className="logo logo-black"><img src="/brand/logo-black.png" alt="Wax Moi Day Spa" width="835" height="240" /></Link>
      </header>
      <article className="policy wrap">
        <p className="eyebrow">Wax Moi Day Spa</p>
        <h1 data-testid="policy-title">{p.title}</h1>
        {p.updated && <p className="policy-updated" data-testid="policy-updated">Last updated {fmt(p.updated)}</p>}
        {p.intro && <p className="policy-intro">{p.intro}</p>}
        {(p.sections || []).filter((s) => s.heading || s.body).map((s, i) => (
          <section key={s.heading || i} data-testid={`policy-section-${i}`}>
            {s.heading && <h2>{s.heading}</h2>}
            {s.body?.split(/\n{2,}/).map((para, j) => <p key={j}>{para}</p>)}
          </section>
        ))}
        <p className="policy-contact">Questions? Call <a href={`tel:${c.contact.phone_call}`}>{c.contact.phone_call_label}</a> or email <a href={`mailto:${c.contact.booking_email}`}>{c.contact.booking_email}</a>.</p>
      </article>
    </div>
  );
}
